import axios from 'axios';
import swal from 'sweetalert';
import { saveAs } from 'file-saver';
import '../../assets/css/icons.css';
import '../../assets/css/style.css';
import '../../assets/css/videocall.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SERVER_IP, ud, jwt, auth_response_flow } from '../../Server';
import 'react-dropdown-tree-select/dist/styles.css';
import { Whiteboard } from "react-fabricjs-whiteboard";
import React, { useEffect, useState, useRef } from 'react';
import RTCMultiConnection from 'rtcmulticonnection-react-js';
import { useReactMediaRecorder } from "react-media-recorder";
import Videochatbox from './Videochatbox';
import { useParams } from 'react-router-dom';

var socket;
var connection = new RTCMultiConnection();

export function Audiocall(props) {
  const { room_id } = useParams();
  const { status, startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder({ screen: true });
  const selectedStream = useRef(null);
  const [liveusers, setLiveusers] = useState([])
  const [liveuserids, setLiveuserids] = useState([])
  const [invitedUser, setInvitedUser] = useState([])
  const [modal, setModal] = useState({ threeDot: false, annotation: false, videochatbox: false })
  const [permission, setPermission] = useState({ audio: true, video: true })

  const [section, setSection] = useState({ allContact: true, favourite: false, myNetwork: false })
  const [favourite, setFavourite] = useState([]);
  const [contact_list, setContactList] = useState([]);
  const [favourite_list, setFavourite_list] = useState([]);
  const [network_list, setNetwork_list] = useState([]);
  const [contact_filtered, setFilteredcontact] = useState([]);
  const [favourite_filtered, setFilteredfavourite] = useState([]);
  const [network_filtered, setFilterednetwork] = useState([]);

  useEffect(() => {
    if (socket === undefined) {
      if (props.socket) {
        socket = props.socket;
      }
    }

    if (props.liveusers) {
      setLiveusers(props.liveusers);
      let arr = []
      props.liveusers.forEach(element => {
        arr.push(element.user_id)
      });
      setLiveuserids(arr)
    }
  }, [props])
  
  useEffect(() => {
    document.getElementsByClassName('xp-topbar')[0].style.display = "none";
    document.getElementsByClassName('xp-leftbar')[0].style.display = "none";
    getNetworkList()
    fetchContactList()
    connection.socketURL = "https://api.assist.simulanis.iom:49445/testshared";

    connection.session = {
      audio: true,
      video: false,
    };

    connection.sdpConstraints.mandatory = {
      OfferToReceiveAudio: true,
      OfferToReceiveVideo: true,
    };

    var bitrates = 512;
    var resolutions = 'Ultra-HD';
    var videoConstraints = {};

    if (resolutions == 'HD') {
      videoConstraints = {
        width: {
          ideal: 500
        },
        height: {
          ideal: 300
        },
        frameRate: 30
      };
    }

    if (resolutions == 'Ultra-HD') {
      videoConstraints = {
        width: {
          ideal: 500
        },
        height: {
          ideal: 300
        },
        frameRate: 30
      };
    }

    connection.mediaConstraints = {
      video: videoConstraints,
      audio: true
    };

    var CodecsHandler = connection.CodecsHandler;

    connection.processSdp = function (sdp) {
    var codecs = 'vp8';

    if (codecs.length) {
      sdp = CodecsHandler.preferCodec(sdp, codecs.toLowerCase());
    }

    if (resolutions == 'HD') {
      sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
        audio: 128,
        video: bitrates,
        screen: bitrates
      });

      sdp = CodecsHandler.setVideoBitrates(sdp, {
        min: bitrates * 8 * 1024,
        max: bitrates * 8 * 1024,
      });
    }

    if (resolutions == 'Ultra-HD') {
      sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
        audio: 128,
        video: bitrates,
        screen: bitrates
      });

      sdp = CodecsHandler.setVideoBitrates(sdp, {
        min: bitrates * 8 * 1024,
        max: bitrates * 8 * 1024,
      });
    }

    return sdp;
    };

    connection.iceServers = [];
    // second step, set STUN url
    connection.iceServers.push({
      urls: 'stun:stunsimulanis.centralindia.cloudapp.azure.com',
      credential: 'simulanis',
      username: 'sspl0522'
    });

    // last step, set TURN url (recommended)
    connection.iceServers.push({
      urls: 'turn:turnsimulanis.centralindia.cloudapp.azure.com',
      credential: 'simulanis',
      username: 'sspl0522'
    });

    connection.onstream = function (event) {
      // Selected Video
      const selectedVideo = selectedStream.current;
      selectedVideo.setAttribute('id', event.streamid);
      selectedVideo.setAttribute('class', 'selectedVideo');
      selectedVideo.setAttribute('autoplay', true);
      selectedVideo.setAttribute('playsinline', true);
      if (event.type === 'local') {
        selectedVideo.volume = 0;
        selectedVideo.setAttribute('muted', true);
      }
      selectedVideo.srcObject = event.stream;
      // selectedVideo.play();
      // All Video
      const video = document.createElement('video');
      video.setAttribute('id', event.streamid);
      video.setAttribute('autoplay', true);
      video.setAttribute('playsinline', true);
      if (event.type === 'local') {
        video.volume = 0;
        video.setAttribute('muted', true);
      }
      video.onclick = videoClickHandler;
      video.srcObject = event.stream;
      // video.play();
      document.getElementById('all-videos').appendChild(video);
    };
    joinRoom();
  }, [])

  const checkVideoExist = () => {
    // All Video
    const allStream = connection.streamEvents.selectAll();
    const streamId = [];
    allStream.forEach((e)=>streamId.push(e.streamid));
    const videos = document.getElementById('all-videos').childNodes;
    videos.forEach(element => streamId.indexOf(element.id)==-1 && element.remove());

    // Maximize video
    if (streamId.length!=0) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
      const selectedVideo = selectedStream.current;
      if (streamId.indexOf(selectedVideo.id)==-1) {
        const video = connection.streamEvents[streamId[0]].stream;
        selectedVideo.setAttribute('id', video.streamid);
        selectedVideo.setAttribute('class', 'selectedVideo');
        selectedVideo.setAttribute('autoplay', true);
        selectedVideo.setAttribute('playsinline', true);
        if (video.type === 'local') {
          selectedVideo.volume = 0;
          selectedVideo.setAttribute('muted', true);
        }
        selectedVideo.srcObject = video;
        // selectedVideo.play();
      }
    }
  }

  useEffect(() => {
    localStorage.setItem('video', 'off')
    setInterval(() => {
      if (connection.attachStreams.length!==0 && localStorage.getItem('video')=='off') {
        connection.attachStreams[0].mute('video')
        setPermission({ ...permission, video: false })
        localStorage.setItem('video', 'on')
      }

      // const video = document.getElementsByTagName('video')
      // const videoArr = [...video]
      // videoArr.forEach((videoElement) => {
      //   connection.streamEvents.selectAll().forEach((element) => {
      //     if (videoElement.id==element.streamid) {
      //       if (element.session.video) {
      //         // videoElement.pause()
      //         videoElement.autoplay = false
      //         videoElement.playsInline = false 
      //         videoElement.poster = ud.profile_logo
      //       } else {
      //         // videoElement.play()
      //         videoElement.autoplay = true
      //         videoElement.playsInline = true
      //       }
      //     }
      //   });
      // });
    }, 100);

    setTimeout(() => {
      const allStream = connection.streamEvents.selectAll();
      allStream.length!==0 && checkVideoExist();
    }, 10000);
  }, [])

  const videoClickHandler = (e) => {
    const clickedVideo = e.target;
    const selectedVideo = selectedStream.current;
    selectedVideo.id = clickedVideo.id;
    selectedVideo.setAttribute('class', 'selectedVideo');
    selectedVideo.setAttribute('autoplay', true);
    selectedVideo.setAttribute('playsinline', true);
    selectedVideo.srcObject = clickedVideo.srcObject;
  }

  const shareScreen = () => {
    connection.addStream({
      screen: true,
      oneway: true
  });
  }

  const endCall = () => {
    let headers = {
      'Content-Type': 'application/json',
      'user_id': (ud.id).toString(),
      'session_id': (ud.session_id).toString(),
      'user_type': (ud.usertype).toString(),
      'main_id': (ud.main_id).toString(),
      'jwt_token': (jwt),
      'c_id': (ud.c_id).toString()
    }
    let data = {
      user_id : ud.id,
      disconnect_type: "SELF",
      room_id : room_id
    }
    axios.post(`${SERVER_IP}/calldisconnected`, data, { withCredentials: true, headers: headers }).then(function (response) {
    if (response.data) {
      const sendData = {
        error: false,
        message_status: "Message sent successfully",
        event: 'SEND_MESSAGE',
        chat_type: 'TEXT',
        from_id: ud.id,
        to_id: room_id,
        room_id: room_id,
        data: [{
          nonremovable: 1,
          datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
          message: `${ud.username} left the chat`,
          message_id: "",
          message_type: 'TEXT',
          file: "",
          from_name: ud.username,
          to_name: "",
          from_email: ud.email,
          to_email: "",
          from_icon: ud.cooperate_logo.split('/icons/')[1],
          to_icon: "",
          from_user_id: ud.id,
          from_profile: "",
          to_profile: "",
          to_user_id: room_id,
          message_thumbnail: "",
          readStatus: ""
        }]
      }
      socket.emit('VEDIO_B_MESSAGE_EVENT', sendData)

      // disconnect with all users
      connection.getAllParticipants().forEach(function(pid) {
        connection.disconnectWith(pid);
      });

      // stop all local cameras
      connection.attachStreams.forEach(function(localStream) {
        localStream.stop();
      });

      // close socket.io connection
      connection.closeSocket();
      window.location.href = '/create/contectlist'
    }}).catch(function (error) {
      swal("Something Went Wrong,Please Retry")
    });
  }

  const joinRoom = () => {
    connection.checkPresence(room_id, function(isRoomExist, roomid) {
      if (isRoomExist === true) {
        connection.join(roomid);
      } else {
        connection.open(roomid);
      }
    });
  }

  const fetchContactList = () => {
    var data = {
      user_id: ud.id,
      datetime: ""
    }
    let headers = {
      'user_id': (ud.id).toString(),
      'session_id': (ud.session_id).toString(),
      'user_type': (ud.usertype).toString(),
      'main_id': (ud.main_id).toString(),
      'jwt_token': (jwt),
      'c_id': (ud.c_id).toString()
    }
    axios.post(`${SERVER_IP}/usersContactList`, data, { withCredentials: true, headers: headers })
    .then(function (response) {
      if (response.data.status) {
        if (response.data.status.error === false) {
          setContactList(response.data.contacts)
          setFilteredcontact(response.data.contacts)
          const newArr = [];
          const favouriteArr = [];
          const favouriteListArr = [];
          response.data.contacts.forEach(element => {
            element.favorite && favouriteArr.push(element.login_id)
            element.favorite && favouriteListArr.push(element)
            const obj = {
              id: element.login_id,
              show: false
            }
            newArr.push(obj)
          });
          setFavourite(favouriteArr)
          setFavourite_list(favouriteListArr)
          setFilteredfavourite(favouriteListArr)
          // setModalshow(newArr)
        }
      } else {
        if (response.data.error === true) {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              fetchContactList();
            }
          })
        }
      }
    }).catch(function (error) {
      swal("Something Went Wrong,Please Retry")
    });
  }

  const getNetworkList = () => {
    var data = { user_id: ud.id }
    let headers = {
      'user_id': (ud.id).toString(),
      'session_id': (ud.session_id).toString(),
      'user_type': (ud.usertype).toString(),
      'main_id': (ud.main_id).toString(),
      'jwt_token': (jwt),
      'c_id': (ud.c_id).toString()
    }
    axios.post(`${SERVER_IP}/usersNetworkList`, data, { withCredentials: true, headers: headers })
    .then(function (response) {
      if (response.data.contacts) {
        setNetwork_list(response.data.contacts);
        setFilterednetwork(response.data.contacts);
      }
    }).catch(function (error) {
      swal("Something Went Wrong,Please Retry")
    });
  }

  //Date Format 2022-07-27 
  const formatDate = (date) => {
    let d = new Date(date);
    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear();
    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  const addUser = (callers) => {
    let clr_obj = []
    callers.map(list => clr_obj.push(list.user_id))
    if (clr_obj.length == 0) {
        return
    }
    let headers = {
        'Content-Type': 'application/json',
        'user_id': (ud.id).toString(),
        'session_id': (ud.session_id).toString(),
        'user_type': (ud.usertype).toString(),
        'main_id': (ud.main_id).toString(),
        'jwt_token': (jwt),
        'c_id': (ud.c_id).toString()
    }
    const data = {
        from_id: ud.id,
        from_user_name: ud.username,
        from_user_email: ud.email,
        from_session_id: ud.session_id,
        to_id: clr_obj,
        call_type: 'ADD',
        call_format: 'F_VIDEO_CALL',
        devicetype: "WebBrowser"
    }
    axios.post(`${SERVER_IP}/callInitiate`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
            if (response.data.error === false) {
            } else {
                swal(response.data.flag_name);
            }
        })
        .catch(function (error) {
            swal("Something Went Wrong,Please Retry")
        });
}

const inviteHandler = () => {
  liveusers.forEach(element => {
    if (invitedUser.indexOf(element.user_id)!=-1) {
      addUser([element])
      inviteEmit(element)
    }
  });
}

  const inviteEmit = (data) => {
    const sendData = {
      error: false,
      message_status: "Message sent successfully",
      event: 'SEND_MESSAGE',
      chat_type: 'TEXT',
      from_id: ud.id,
      to_id: room_id,
      room_id: room_id,
      data: [{
        nonremovable: 1,
        datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
        message: `${data.user_name} was invited to the meeting`,
        message_id: "",
        message_type: 'TEXT',
        file: "",
        from_name: ud.username,
        to_name: "",
        from_email: ud.email,
        to_email: "",
        from_icon: ud.cooperate_logo.split('/icons/')[1],
        to_icon: "",
        from_user_id: ud.id,
        from_profile: "",
        to_profile: "",
        to_user_id: room_id,
        message_thumbnail: "",
        readStatus: ""
      }]
    }
    socket.emit('VEDIO_B_MESSAGE_EVENT', sendData)
    setInvitedUser([])
  }

  const muteVideo = () => {
    if (permission.video==true) {
      connection.streamEvents.selectFirst({local: true}).stream.mute('video');
      setPermission({ ...permission, video: false })
    } else {
      connection.streamEvents.selectFirst({local: true}).stream.unmute('video');
      setPermission({ ...permission, video: true })
    }
  }

  const muteAudio = () => {
    if (permission.audio==true) {
      connection.streamEvents.selectFirst({local: true}).stream.mute('audio');
      setPermission({ ...permission, audio: false })
    } else {
      connection.streamEvents.selectFirst({local: true}).stream.unmute('audio');
      setPermission({ ...permission, audio: true })
    }
  }

  useEffect(() => {
    const whiteboardContainer = document.getElementsByClassName('canvas-container')
    const whiteboardButtons = document.getElementsByClassName('Whiteboard_toolbar__6FIr+')
    const upper = document.getElementsByClassName('upper-canvas')
    const lower = document.getElementsByClassName('lower-canvas')
    if (whiteboardButtons.length!=0 && whiteboardContainer.length!=0) {
      whiteboardContainer[0].style.width = "58rem"
      whiteboardContainer[0].style.top = "37px"
      whiteboardContainer[0].style.left = "200px"
      upper[0].style.border = "none"
      lower[0].style.border = "none"

      whiteboardButtons[0].style.position = "relative"
      whiteboardButtons[0].style.top = "19px"
      whiteboardButtons[0].style.left = "195px"
    }
  }, [modal.annotation])
    
  return (
  <div className="calling_window" style={{zIndex: "999999"}}>
      <div id='video-call-parent'>
        <div id='video-container'>
          <div>
            {/* <div id="handler">
              <i className="fa-solid fa-video mr-3" onClick={otherVideoMute}></i>
              <i className="fa-solid fa-microphone"></i>
            </div> */}
            <video id='selectedVideo' ref={selectedStream}></video>
            {modal.annotation &&
            <div id='annotationParent'>
              <Whiteboard aspectRatio={4 / 3}/>
            </div>}
          </div>
          <div id="all-videos-parent">
            <div id="all-videos"></div>
          </div>
          {status=='stopped' &&
          <div id="recorded-video-parent">
            <button type="button" className="btn btn-info" onClick={()=>saveAs(mediaBlobUrl, "recorded.mp4")}>Download recorded video</button>
          </div>}
        </div>

        <div id='bottom-navigators'>
          <button type="button" className="btn btn-round btn-secondary" data-toggle="modal" data-target="#invite-modal"><i className="fa-solid fa-user-plus text-dark"></i></button>
          <div>
            {permission.video ? <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteVideo}><i className="fa-solid fa-video text-dark"></i></button> : <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteVideo}><i className="fa-solid fa-video-slash text-dark"></i></button>}
            {permission.audio ? <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteAudio}><i className="fa-solid fa-microphone text-dark"></i></button> : <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteAudio}><i className="fa-solid fa-microphone-slash text-dark"></i></button>}

            <button type="button" onClick={endCall} className="btn btn-round btn-primary mr-3"><i className="mdi mdi-phone-hangup"></i></button>
            <button type="button" onClick={()=>modal.threeDot?setModal({ ...modal, threeDot: false }):setModal({ ...modal, threeDot: true })} className="btn btn-round btn-secondary mr-3"><i className="fa-solid fa-ellipsis-vertical text-dark"></i></button>

            {modal.threeDot && 
            <div id='three-dot-menu'>
              <button onClick={()=>{shareScreen();setModal({ ...modal, threeDot: false })}}>Share screen</button>
              {status=='recording' ? <button onClick={()=>{stopRecording();setModal({ ...modal, threeDot: false })}}>Stop recording</button> : <button onClick={()=>{startRecording();setModal({ ...modal, threeDot: false })}}>Record screen</button>}
              <button onClick={()=>modal.annotation ? setModal({ ...modal, threeDot: false, annotation: false }) : setModal({ ...modal, threeDot: false, annotation: true })}>Annotation</button>
            </div>}
          </div>
          <button type="button" className="btn btn-round btn-secondary" onClick={()=>setModal({ ...modal, videochatbox: true })}><i className="mdi mdi-message-text-outline text-dark"></i></button>
        </div>
      
        {modal.videochatbox &&
        <div className="modal fade show" style={{display: 'block'}} role="dialog">
          <Videochatbox modal={modal} setModal={setModal} room_id={room_id} />
        </div>}

        <div className="modal fade bd-example-modal-lg" id="invite-modal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="invite-modal-label" aria-hidden="true">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content" style={{height: '27rem'}}>
              <div className="modal-header">
                <h5 className="modal-title" id="invite-modal-label">Add People</h5>
                <button type="button" className="btn btn-outline-primary" data-dismiss="modal"><i className="fa-solid fa-xmark"></i></button>
              </div>
              <div className="modal-body">
                <div id='divider'>
                  <span onClick={()=>setSection({ ...section, allContact: true, favourite: false, myNetwork: false })} style={{border: section.allContact?'1px solid #2B343A':'1px solid #dcdcdc'}}>All Contact</span>
                  <span onClick={()=>setSection({ ...section, allContact: false, favourite: true, myNetwork: false })} style={{border: section.favourite?'1px solid #2B343A':'1px solid #dcdcdc'}}>Favourite</span>
                  <span onClick={()=>setSection({ ...section, allContact: false, favourite: false, myNetwork: true })} style={{border: section.myNetwork?'1px solid #2B343A':'1px solid #dcdcdc'}}>My Network</span>
                  {section.allContact &&
                  <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                      const result = contact_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                      setContactList(result)
                  }}/>}
                  {section.favourite &&
                  <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                      const result = favourite_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                      setFavourite_list(result)
                  }}/>}
                  {section.myNetwork &&
                  <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
                      const result = network_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
                      setNetwork_list(result)
                  }}/>}
                </div>

                <div style={{marginTop: '1.5rem'}}>
                  {section.allContact &&
                  <>
                    {contact_list.map((element, i)=>{
                      return (
                        <div className='d-flex' key={i}>
                          {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
                          <div class="form-check">
                            <input type="checkbox" disabled={liveuserids.indexOf(element.login_id)==-1} class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
                              if (invitedUser.indexOf(element.login_id)==-1) {
                                setInvitedUser([...invitedUser, element.login_id])
                              } else {
                                let arr = [...invitedUser]
                                arr.splice(invitedUser.indexOf(element.login_id), 1)
                                setInvitedUser(arr)
                              }
                            }}/>
                            <label class="form-check-label" for="exampleCheck1">{element.email}</label>
                          </div>
                      </div>
                      )
                    })}
                  </>}
                  {section.favourite &&
                  <>
                    {favourite_list.map((element, i)=>{
                      return (
                        <div className='d-flex' key={i}>
                          {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
                          <div class="form-check">
                            <input type="checkbox" disabled={liveuserids.indexOf(element.login_id)==-1} class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
                              if (invitedUser.indexOf(element.login_id)==-1) {
                                setInvitedUser([...invitedUser, element.login_id])
                              } else {
                                let arr = [...invitedUser]
                                arr.splice(invitedUser.indexOf(element.login_id), 1)
                                setInvitedUser(arr)
                              }
                            }}/>
                            <label class="form-check-label" for="exampleCheck1">{element.email}</label>
                          </div>
                      </div>
                      )
                    })}
                  </>}
                  {section.myNetwork &&
                  <>
                    {network_list.map((element, i)=>{
                      return (
                        <div className='d-flex' key={i}>
                          {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
                          <div class="form-check">
                            <input type="checkbox" disabled={liveuserids.indexOf(element.login_id)==-1} class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
                              if (invitedUser.indexOf(element.login_id)==-1) {
                                setInvitedUser([...invitedUser, element.login_id])
                              } else {
                                let arr = [...invitedUser]
                                arr.splice(invitedUser.indexOf(element.login_id), 1)
                                setInvitedUser(arr)
                              }
                            }}/>
                            <label class="form-check-label" for="exampleCheck1">{element.email}</label>
                          </div>
                      </div>
                      )
                    })}
                  </>}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={inviteHandler}>Invite</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  )
}

// export function Videocall(props) {
//   const { room_id } = useParams();
//   const { status, startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder({ screen: true });
//   const selectedStream = useRef(null);
//   const [liveusers, setLiveusers] = useState([])
//   const [liveuserids, setLiveuserids] = useState([])
//   const [invitedUser, setInvitedUser] = useState([])
//   const [modal, setModal] = useState({ threeDot: false, annotation: false, videochatbox: false })
//   const [permission, setPermission] = useState({ audio: true, video: true })

//   const [section, setSection] = useState({ allContact: true, favourite: false, myNetwork: false })
//   const [favourite, setFavourite] = useState([]);
//   const [contact_list, setContactList] = useState([]);
//   const [favourite_list, setFavourite_list] = useState([]);
//   const [network_list, setNetwork_list] = useState([]);
//   const [contact_filtered, setFilteredcontact] = useState([]);
//   const [favourite_filtered, setFilteredfavourite] = useState([]);
//   const [network_filtered, setFilterednetwork] = useState([]);

//   useEffect(() => {
//     if (socket === undefined) {
//       if (props.socket) {
//         socket = props.socket;
//       }
//     }

//     if (props.liveusers) {
//       setLiveusers(props.liveusers);
//       let arr = []
//       props.liveusers.forEach(element => {
//         arr.push(element.user_id)
//       });
//       setLiveuserids(arr)
//     }
//   }, [props])
  
//   useEffect(() => {
//     document.getElementsByClassName('xp-topbar')[0].style.display = "none";
//     document.getElementsByClassName('xp-leftbar')[0].style.display = "none";
//     getNetworkList()
//     fetchContactList()


//     connection.session = {
//       audio: true,
//       video: true,
//     };

//     connection.sdpConstraints.mandatory = {
//       OfferToReceiveAudio: true,
//       OfferToReceiveVideo: true,
//     };

//     var bitrates = 512;
//     var resolutions = 'Ultra-HD';
//     var videoConstraints = {};

//     if (resolutions == 'HD') {
//       videoConstraints = {
//         width: {
//           ideal: 500
//         },
//         height: {
//           ideal: 300
//         },
//         frameRate: 30
//       };
//     }

//     if (resolutions == 'Ultra-HD') {
//       videoConstraints = {
//         width: {
//           ideal: 500
//         },
//         height: {
//           ideal: 300
//         },
//         frameRate: 30
//       };
//     }

//     connection.mediaConstraints = {
//       video: videoConstraints,
//       audio: true
//     };

//     var CodecsHandler = connection.CodecsHandler;

//     connection.processSdp = function (sdp) {
//     var codecs = 'vp8';

//     if (codecs.length) {
//       sdp = CodecsHandler.preferCodec(sdp, codecs.toLowerCase());
//     }

//     if (resolutions == 'HD') {
//       sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
//         audio: 128,
//         video: bitrates,
//         screen: bitrates
//       });

//       sdp = CodecsHandler.setVideoBitrates(sdp, {
//         min: bitrates * 8 * 1024,
//         max: bitrates * 8 * 1024,
//       });
//     }

//     if (resolutions == 'Ultra-HD') {
//       sdp = CodecsHandler.setApplicationSpecificBandwidth(sdp, {
//         audio: 128,
//         video: bitrates,
//         screen: bitrates
//       });

//       sdp = CodecsHandler.setVideoBitrates(sdp, {
//         min: bitrates * 8 * 1024,
//         max: bitrates * 8 * 1024,
//       });
//     }

//     return sdp;
//     };

//     connection.iceServers = [];
//     // second step, set STUN url
//     connection.iceServers.push({
//       urls: 'stun:stunsimulanis.centralindia.cloudapp.azure.com',
//       credential: 'simulanis',
//       username: 'sspl0522'
//     });

//     // last step, set TURN url (recommended)
//     connection.iceServers.push({
//       urls: 'turn:turnsimulanis.centralindia.cloudapp.azure.com',
//       credential: 'simulanis',
//       username: 'sspl0522'
//     });

//     connection.onstream = function (event) {
//       // Selected Video
//       const selectedVideo = selectedStream.current;
//       selectedVideo.setAttribute('id', event.streamid);
//       selectedVideo.setAttribute('class', 'selectedVideo');
//       selectedVideo.setAttribute('autoplay', true);
//       selectedVideo.setAttribute('playsinline', true);
//       if (event.type === 'local') {
//         selectedVideo.volume = 0;
//         selectedVideo.setAttribute('muted', true);
//       }
//       selectedVideo.srcObject = event.stream;
//       selectedVideo.play();
//       // All Video
//       const video = document.createElement('video');
//       video.setAttribute('id', event.streamid);
//       video.setAttribute('autoplay', true);
//       video.setAttribute('playsinline', true);
//       if (event.type === 'local') {
//         video.volume = 0;
//         video.setAttribute('muted', true);
//       }
//       video.onclick = videoClickHandler;
//       video.srcObject = event.stream;
//       video.play();
//       document.getElementById('all-videos').appendChild(video);
//     };
//     joinRoom();
//   }, [])

//   const checkVideoExist = () => {
//     // All Video
//     const allStream = connection.streamEvents.selectAll();
//     const streamId = [];
//     allStream.forEach((e)=>streamId.push(e.streamid));
//     const videos = document.getElementById('all-videos').childNodes;
//     videos.forEach(element => streamId.indexOf(element.id)==-1 && element.remove());

//     // Maximize video
//     if (streamId.length!=0) {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             
//       const selectedVideo = selectedStream.current;
//       if (streamId.indexOf(selectedVideo.id)==-1) {
//         const video = connection.streamEvents[streamId[0]].stream;
//         selectedVideo.setAttribute('id', video.streamid);
//         selectedVideo.setAttribute('class', 'selectedVideo');
//         selectedVideo.setAttribute('autoplay', true);
//         selectedVideo.setAttribute('playsinline', true);
//         if (video.type === 'local') {
//           selectedVideo.volume = 0;
//           selectedVideo.setAttribute('muted', true);
//         }
//         selectedVideo.srcObject = video;
//         selectedVideo.play();
//       }
//     }
//   }

//   useEffect(() => {
//     setTimeout(() => {
//       const allStream = connection.streamEvents.selectAll();
//       allStream.length!==0 && checkVideoExist();
//     }, 10000);
//   }, [])

//   const videoClickHandler = (e) => {
//     const clickedVideo = e.target;
//     const selectedVideo = selectedStream.current;
//     selectedVideo.id = clickedVideo.id;
//     selectedVideo.setAttribute('class', 'selectedVideo');
//     selectedVideo.setAttribute('autoplay', true);
//     selectedVideo.setAttribute('playsinline', true);
//     selectedVideo.srcObject = clickedVideo.srcObject;
//   }

//   const shareScreen = () => {
//     connection.addStream({
//       screen: true,
//       oneway: true
//   });
//   }

//   const endCall = () => {
//     let headers = {
//       'Content-Type': 'application/json',
//       'user_id': (ud.id).toString(),
//       'session_id': (ud.session_id).toString(),
//       'user_type': (ud.usertype).toString(),
//       'main_id': (ud.main_id).toString(),
//       'jwt_token': (jwt),
//       'c_id': (ud.c_id).toString()
//     }
//     let data = {
//       user_id : ud.id,
//       disconnect_type: "SELF",
//       room_id : room_id
//     }
//     axios.post(`${SERVER_IP}/calldisconnected`, data, { withCredentials: true, headers: headers }).then(function (response) {
//     if (response.data) {
//       const sendData = {
//         error: false,
//         message_status: "Message sent successfully",
//         event: 'SEND_MESSAGE',
//         chat_type: 'TEXT',
//         from_id: ud.id,
//         to_id: room_id,
//         room_id: room_id,
//         data: [{
//           nonremovable: 1,
//           datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
//           message: `${ud.username} left the chat`,
//           message_id: "",
//           message_type: 'TEXT',
//           file: "",
//           from_name: ud.username,
//           to_name: "",
//           from_email: ud.email,
//           to_email: "",
//           from_icon: ud.cooperate_logo.split('/icons/')[1],
//           to_icon: "",
//           from_user_id: ud.id,
//           from_profile: "",
//           to_profile: "",
//           to_user_id: room_id,
//           message_thumbnail: "",
//           readStatus: ""
//         }]
//       }
//       socket.emit('VEDIO_B_MESSAGE_EVENT', sendData)

//       // disconnect with all users
//       connection.getAllParticipants().forEach(function(pid) {
//         connection.disconnectWith(pid);
//       });

//       // stop all local cameras
//       connection.attachStreams.forEach(function(localStream) {
//         localStream.stop();
//       });

//       // close socket.io connection
//       connection.closeSocket();
//       window.location.href = '/create/contectlist'
//     }}).catch(function (error) {
//       swal("Something Went Wrong,Please Retry")
//     });
//   }

//   const joinRoom = () => {
//     connection.checkPresence(room_id, function(isRoomExist, roomid) {
//       if (isRoomExist === true) {
//         connection.join(roomid);
//       } else {
//         connection.open(roomid);
//       }
//     });
//   }

//   const fetchContactList = () => {
//     var data = {
//       user_id: ud.id,
//       datetime: ""
//     }
//     let headers = {
//       'user_id': (ud.id).toString(),
//       'session_id': (ud.session_id).toString(),
//       'user_type': (ud.usertype).toString(),
//       'main_id': (ud.main_id).toString(),
//       'jwt_token': (jwt),
//       'c_id': (ud.c_id).toString()
//     }
//     axios.post(`${SERVER_IP}/usersContactList`, data, { withCredentials: true, headers: headers })
//     .then(function (response) {
//       if (response.data.status) {
//         if (response.data.status.error === false) {
//           setContactList(response.data.contacts)
//           setFilteredcontact(response.data.contacts)
//           const newArr = [];
//           const favouriteArr = [];
//           const favouriteListArr = [];
//           response.data.contacts.forEach(element => {
//             element.favorite && favouriteArr.push(element.login_id)
//             element.favorite && favouriteListArr.push(element)
//             const obj = {
//               id: element.login_id,
//               show: false
//             }
//             newArr.push(obj)
//           });
//           setFavourite(favouriteArr)
//           setFavourite_list(favouriteListArr)
//           setFilteredfavourite(favouriteListArr)
//           // setModalshow(newArr)
//         }
//       } else {
//         if (response.data.error === true) {
//           auth_response_flow(response.data, (return_response) => {
//             if (return_response.error === false && return_response.retry === true) {
//               fetchContactList();
//             }
//           })
//         }
//       }
//     }).catch(function (error) {
//       swal("Something Went Wrong,Please Retry")
//     });
//   }

//   const getNetworkList = () => {
//     var data = { user_id: ud.id }
//     let headers = {
//       'user_id': (ud.id).toString(),
//       'session_id': (ud.session_id).toString(),
//       'user_type': (ud.usertype).toString(),
//       'main_id': (ud.main_id).toString(),
//       'jwt_token': (jwt),
//       'c_id': (ud.c_id).toString()
//     }
//     axios.post(`${SERVER_IP}/usersNetworkList`, data, { withCredentials: true, headers: headers })
//     .then(function (response) {
//       if (response.data.contacts) {
//         setNetwork_list(response.data.contacts);
//         setFilterednetwork(response.data.contacts);
//       }
//     }).catch(function (error) {
//       swal("Something Went Wrong,Please Retry")
//     });
//   }

//   //Date Format 2022-07-27 
//   const formatDate = (date) => {
//     let d = new Date(date);
//     let month = (d.getMonth() + 1).toString();
//     let day = d.getDate().toString();
//     let year = d.getFullYear();
//     if (month.length < 2) {
//       month = '0' + month;
//     }
//     if (day.length < 2) {
//       day = '0' + day;
//     }
//     return [year, month, day].join('-');
//   }

//   const addUser = (callers) => {
//     let clr_obj = []
//     callers.map(list => clr_obj.push(list.user_id))
//     if (clr_obj.length == 0) {
//         return
//     }
//     let headers = {
//         'Content-Type': 'application/json',
//         'user_id': (ud.id).toString(),
//         'session_id': (ud.session_id).toString(),
//         'user_type': (ud.usertype).toString(),
//         'main_id': (ud.main_id).toString(),
//         'jwt_token': (jwt),
//         'c_id': (ud.c_id).toString()
//     }
//     const data = {
//         from_id: ud.id,
//         from_user_name: ud.username,
//         from_user_email: ud.email,
//         from_session_id: ud.session_id,
//         to_id: clr_obj,
//         call_type: 'ADD',
//         call_format: 'F_VIDEO_CALL',
//         devicetype: "WebBrowser"
//     }
//     axios.post(`${SERVER_IP}/callInitiate`, data, { withCredentials: true, headers: headers })
//         .then(function (response) {
//             if (response.data.error === false) {
//             } else {
//                 swal(response.data.flag_name);
//             }
//         })
//         .catch(function (error) {
//             swal("Something Went Wrong,Please Retry")
//         });
// }

// const inviteHandler = () => {
//   liveusers.forEach(element => {
//     if (invitedUser.indexOf(element.user_id)>-1) {
//       addUser([element])
//       inviteEmit(element)
//     }
//   });
// }

//   const inviteEmit = (data) => {
//     const sendData = {
//       error: false,
//       message_status: "Message sent successfully",
//       event: 'SEND_MESSAGE',
//       chat_type: 'TEXT',
//       from_id: ud.id,
//       to_id: room_id,
//       room_id: room_id,
//       data: [{
//         nonremovable: 1,
//         datetime: formatDate(new Date())+" "+new Date().toLocaleTimeString(),
//         message: `${data.user_name} was invited to the meeting`,
//         message_id: "",
//         message_type: 'TEXT',
//         file: "",
//         from_name: ud.username,
//         to_name: "",
//         from_email: ud.email,
//         to_email: "",
//         from_icon: ud.cooperate_logo.split('/icons/')[1],
//         to_icon: "",
//         from_user_id: ud.id,
//         from_profile: "",
//         to_profile: "",
//         to_user_id: room_id,
//         message_thumbnail: "",
//         readStatus: ""
//       }]
//     }
//     socket.emit('VEDIO_B_MESSAGE_EVENT', sendData)
//     setInvitedUser([])
//   }

//   const muteVideo = () => {
//     if (permission.video==true) {
//       connection.streamEvents.selectFirst({local: true}).stream.mute('video');
//       setPermission({ ...permission, video: false })
//     } else {
//       connection.streamEvents.selectFirst({local: true}).stream.unmute('video');
//       setPermission({ ...permission, video: true })
//     }
//   }

//   const muteAudio = () => {
//     if (permission.audio==true) {
//       connection.streamEvents.selectFirst({local: true}).stream.mute('audio');
//       setPermission({ ...permission, audio: false })
//     } else {
//       connection.streamEvents.selectFirst({local: true}).stream.unmute('audio');
//       setPermission({ ...permission, audio: true })
//     }
//   }

//   useEffect(() => {
//     const whiteboardContainer = document.getElementsByClassName('canvas-container')
//     const whiteboardButtons = document.getElementsByClassName('Whiteboard_toolbar__6FIr+')
//     const upper = document.getElementsByClassName('upper-canvas')
//     const lower = document.getElementsByClassName('lower-canvas')
//     if (whiteboardButtons.length!=0 && whiteboardContainer.length!=0) {
//       whiteboardContainer[0].style.width = "58rem"
//       whiteboardContainer[0].style.top = "37px"
//       whiteboardContainer[0].style.left = "200px"
//       upper[0].style.border = "none"
//       lower[0].style.border = "none"

//       whiteboardButtons[0].style.position = "relative"
//       whiteboardButtons[0].style.top = "19px"
//       whiteboardButtons[0].style.left = "195px"
//     }
//   }, [modal.annotation])
    
//   return (
//   <div className="calling_window" style={{zIndex: "999999"}}>
//       <div id='video-call-parent'>
//         <div id='video-container'>
//           <div>
//             {/* <div id="handler">
//               <i className="fa-solid fa-video mr-3" onClick={otherVideoMute}></i>
//               <i className="fa-solid fa-microphone"></i>
//             </div> */}
//             <video id='selectedVideo' ref={selectedStream}></video>
//             {modal.annotation &&
//             <div id='annotationParent'>
//               <Whiteboard aspectRatio={4 / 3}/>
//             </div>}
//           </div>
//           <div id="all-videos-parent">
//             <div id="all-videos"></div>
//           </div>
//           {status=='stopped' &&
//           <div id="recorded-video-parent">
//             <button type="button" className="btn btn-info" onClick={()=>saveAs(mediaBlobUrl, "recorded.mp4")}>Download recorded video</button>
//           </div>}
//         </div>

//         <div id='bottom-navigators'>
//           <button type="button" className="btn btn-round btn-secondary" data-toggle="modal" data-target="#invite-modal"><i className="fa-solid fa-user-plus text-dark"></i></button>
//           <div>
//             {permission.video ? <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteVideo}><i className="fa-solid fa-video text-dark"></i></button> : <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteVideo}><i className="fa-solid fa-video-slash text-dark"></i></button>}
//             {permission.audio ? <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteAudio}><i className="fa-solid fa-microphone text-dark"></i></button> : <button type="button" className="btn btn-round btn-secondary mr-3" onClick={muteAudio}><i className="fa-solid fa-microphone-slash text-dark"></i></button>}

//             <button type="button" onClick={endCall} className="btn btn-round btn-primary mr-3"><i className="mdi mdi-phone-hangup"></i></button>
//             <button type="button" onClick={()=>modal.threeDot?setModal({ ...modal, threeDot: false }):setModal({ ...modal, threeDot: true })} className="btn btn-round btn-secondary mr-3"><i className="fa-solid fa-ellipsis-vertical text-dark"></i></button>

//             {modal.threeDot && 
//             <div id='three-dot-menu'>
//               <button onClick={()=>{shareScreen();setModal({ ...modal, threeDot: false })}}>Share screen</button>
//               {status=='recording' ? <button onClick={()=>{stopRecording();setModal({ ...modal, threeDot: false })}}>Stop recording</button> : <button onClick={()=>{startRecording();setModal({ ...modal, threeDot: false })}}>Record screen</button>}
//               <button onClick={()=>modal.annotation ? setModal({ ...modal, threeDot: false, annotation: false }) : setModal({ ...modal, threeDot: false, annotation: true })}>Annotation</button>
//             </div>}
//           </div>
//           <button type="button" className="btn btn-round btn-secondary" onClick={()=>setModal({ ...modal, videochatbox: true })}><i className="mdi mdi-message-text-outline text-dark"></i></button>
//         </div>
      
//         {modal.videochatbox &&
//         <div className="modal fade show" style={{display: 'block'}} role="dialog">
//           <Videochatbox modal={modal} setModal={setModal} room_id={room_id} />
//         </div>}

//         <div className="modal fade bd-example-modal-lg" id="invite-modal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="invite-modal-label" aria-hidden="true">
//           <div className="modal-dialog modal-lg modal-dialog-centered">
//             <div className="modal-content" style={{height: '27rem'}}>
//               <div className="modal-header">
//                 <h5 className="modal-title" id="invite-modal-label">Add People</h5>
//                 <button type="button" className="btn btn-outline-primary" data-dismiss="modal"><i className="fa-solid fa-xmark"></i></button>
//               </div>
//               <div className="modal-body">
//                 <div id='divider'>
//                   <span onClick={()=>setSection({ ...section, allContact: true, favourite: false, myNetwork: false })} style={{border: section.allContact?'1px solid #2B343A':'1px solid #dcdcdc'}}>All Contact</span>
//                   <span onClick={()=>setSection({ ...section, allContact: false, favourite: true, myNetwork: false })} style={{border: section.favourite?'1px solid #2B343A':'1px solid #dcdcdc'}}>Favourite</span>
//                   <span onClick={()=>setSection({ ...section, allContact: false, favourite: false, myNetwork: true })} style={{border: section.myNetwork?'1px solid #2B343A':'1px solid #dcdcdc'}}>My Network</span>
//                   {section.allContact &&
//                   <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
//                       const result = contact_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
//                       setContactList(result)
//                   }}/>}
//                   {section.favourite &&
//                   <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
//                       const result = favourite_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
//                       setFavourite_list(result)
//                   }}/>}
//                   {section.myNetwork &&
//                   <input className="form-control" type="search" placeholder="Search" onChange={(e)=>{
//                       const result = network_filtered.filter((element)=>element.name.toLowerCase().includes(e.target.value.toLowerCase()))
//                       setNetwork_list(result)
//                   }}/>}
//                 </div>

//                 <div style={{marginTop: '1.5rem'}}>
//                   {section.allContact &&
//                   <>
//                     {contact_list.map((element, i)=>{
//                       return (
//                         <div className='d-flex' key={i}>
//                           {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
//                           <div class="form-check">
//                             <input type="checkbox" class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
//                               if (invitedUser.indexOf(element.login_id)==-1) {
//                                 setInvitedUser([...invitedUser, element.login_id])
//                               } else {
//                                 let arr = [...invitedUser]
//                                 arr.splice(invitedUser.indexOf(element.login_id), 1)
//                                 setInvitedUser(arr)
//                               }
//                             }}/>
//                             <label class="form-check-label" for="exampleCheck1">{element.email}</label>
//                           </div>
//                       </div>
//                       )
//                     })}
//                   </>}
//                   {section.favourite &&
//                   <>
//                     {favourite_list.map((element, i)=>{
//                       return (
//                         <div className='d-flex' key={i}>
//                           {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
//                           <div class="form-check">
//                             <input type="checkbox" class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
//                               if (invitedUser.indexOf(element.login_id)==-1) {
//                                 setInvitedUser([...invitedUser, element.login_id])
//                               } else {
//                                 let arr = [...invitedUser]
//                                 arr.splice(invitedUser.indexOf(element.login_id), 1)
//                                 setInvitedUser(arr)
//                               }
//                             }}/>
//                             <label class="form-check-label" for="exampleCheck1">{element.email}</label>
//                           </div>
//                       </div>
//                       )
//                     })}
//                   </>}
//                   {section.myNetwork &&
//                   <>
//                     {network_list.map((element, i)=>{
//                       return (
//                         <div className='d-flex' key={i}>
//                           {liveuserids.indexOf(element.login_id)>-1 ? <span id="onlineStatus"></span> : <span id="offlineStatus"></span>}
//                           <div class="form-check">
//                             <input type="checkbox" disabled={liveuserids.indexOf(element.login_id)==-1} class="form-check-input" id="exampleCheck1" checked={invitedUser.indexOf(element.login_id)!=-1} onChange={()=>{
//                               if (invitedUser.indexOf(element.login_id)==-1) {
//                                 setInvitedUser([...invitedUser, element.login_id])
//                               } else {
//                                 let arr = [...invitedUser]
//                                 arr.splice(invitedUser.indexOf(element.login_id), 1)
//                                 setInvitedUser(arr)
//                               }
//                             }}/>
//                             <label class="form-check-label" for="exampleCheck1">{element.email}</label>
//                           </div>
//                       </div>
//                       )
//                     })}
//                   </>}
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={inviteHandler}>Invite</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//   </div>
//   )
// }